<template>
  <div class="animated fadeIn">
    <div v-if="loading" style="display: flex; justify-content: center; align-items: center; height: 60vh;">
      <LoadingCard />
    </div>
    <template v-else>
      <b-row>
        <b-col
          lg="12"
          style="display:block; text-align:center;padding-bottom:15px;font-size:1.2em;"
          v-if="total > 0"
        >
          <span style="padding:5px;">Total Records:</span>
          <b>{{
            total
          }}</b>
          <b-button
            class="download-button"
            variant="primary"
            size="lg"
            @click="downloadExcel()"
          >
            <LoadingCard
              height="20px"
              width="20px"
              v-if="loading2019"
            ></LoadingCard>
            <i v-else class="fa fa-file-excel-o" aria-hidden="true"></i>
            Download
          </b-button>
        </b-col>
        <b-col lg="12">
          <c-table
            :table-data="type === 'totalTested' ? pagedData : data"
            :fields="fields"
            :caption="tableCaption"
            :noDataMessage="message"
            :loading="loading"
          >
          </c-table>
        </b-col>
        <b-col v-if="type === 'totalTested' && total > perPage" lg="12" class="d-flex justify-content-center mt-2">
          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="perPage"
            :limit="7"
          />
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import LoadingCard from "../../../components/shared/LoadingCard.vue";
import cTable from "./Table.vue";
import DateModal from "../../../components/shared/DateModal.vue";
import Datepicker from "vuejs-datepicker";
import { modelStore } from '@/stores/modelStore';

export default {
  props: [
    "location",
    "productGroup",
    "type",
    "date_from",
    "date_to",
    "year",
    "month",
    "prodModel",
    "thirdPartyClientId",
    "productModel",
    "prg",
    "clients",
    "failure",
    "fns_part",
    "city",
    "client",
    "equipment_status"
  ],
  name: "tables",
  components: { cTable, LoadingCard, DateModal, Datepicker },
  data: () => {
    return {
      locationParam: "",
      excelDownloadUrl: "",
      excelDownloadParams: {
        xml: "true"
      },
      dateFrom: "",
      dateTo: "",
      message: "",
      loading2019: false,
      loadingExcel: false,
      clientsId: "",
      productGroupParam: "",
      dateFromParam: "",
      modelParam: "",
      dateToParam: "",
      selectedYear: "",
      selectedMonth: "",
      product: "",
      manufacturer: "",
      title: "",
      loading: true,
      data: [],
      total: 0,
      currentPage: 1,
      perPage: 100,
      fields: [
        { key: "fnsid", label: "ARC ID", sortable: true },
        { key: "locat", label: "Location" },
        { key: "sernm", label: "Serial#" },
        {
          key: "pMake",
          label: "Manufacturer",
          sortable: true,
          style: "width: 250px"
        },
        { key: "pMode", label: "Model" },
        {
          key: "compl",
          label: "Complaint",
          sortable: true,
          tdClass: "complaintClass"
        },
        { key: "loctn", label: "Status", sortable: true }
      ]
    };
  },
  computed: {
    pagedData() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.data.slice(start, start + this.perPage);
    },
    tableCaption() {
      return this.title;
    },
    selectedModel() {
      return modelStore.selectedModel;
    },
    flagChanged() {
      return modelStore.isSpaced;
    },
  },
  watch: {
    selectedModel() {
      this.initLoad();
    },
    flagChanged() {
      this.initLoad();
    },
    data(newVal) {
      if (!newVal || newVal.length === 0) {
        this.message = "No data found";
        this.total = 0;
      } else {
        this.total = newVal.length;
      }
      this.currentPage = 1;
      this.loading = false;
    }
  },
  methods: {
    initLoad() {
      if (this.type != "top") {
        if (this.location) {
          this.locationParam = this.location.substring(
            0,
            this.location.lastIndexOf("(")
          );
        }
        if (this.productGroup) {
          this.productGroupParam = this.productGroup.substring(
            0,
            this.productGroup.lastIndexOf("(")
          );
        }
        if (this.productModel) {
          this.modelParam = this.productModel.substring(
            0,
            this.productModel.lastIndexOf("(")
          );
        }
        this.title =
          this.type.toLocaleUpperCase() +
          (this.productGroupParam ? (" - " +
            this.productGroupParam) : "") +
          (this.locationParam ? (" in " +
            this.locationParam) : "");
      } else {
        this.locationParam = this.location;
        this.productGroupParam = this.prg.substring(0, this.prg.lastIndexOf("("));
        this.title = this.prg + " Shipped to " + this.locationParam;
      }
      this.locationParam = this.locationParam || this.location;
      this.clientsId = this.clients;
      this.dateFromParam = this.date_from;
      this.dateToParam = this.date_to;
      this.selectedYear = this.year;
      this.selectedMonth = this.month;
      this.product = this.prodModel;
      this.manufacturer = this.thirdPartyClientId;
      if (this.type === "Received" || this.type === "received") {
        this.fetchChartDataReceived();
      }
      if (this.type === "Shipped" || this.type === "shipped") {
        this.fetchChartDataShipped();
      }
      if (this.type === "top") {
        this.fetchChartDataShipped();
      }
      if (this.type === "war") {
        this.fetchChartDataWar();
      }
      if (this.type === "backlog") {
        this.fetchChartDatabacklog();
      }
      if (this.type === "city") {
        this.fetchChartDataCityPerGroup();
      }
      let typeSplit = this.type.split("(");
      if (typeSplit[0] === "Part") {
        this.title = "Failure by Part";
        this.fetchChartDataPart();
      }
      if (typeSplit[0] === "Designator") {
        this.title = "Failure by Designator";
        this.fetchChartDataDesignator();
      }
      if (typeSplit[0] === "Failure") {
        this.title = "Failure by Failure";
        this.fetchChartDataFailure();
      }
      if (typeSplit[0] === "Complaint") {
        this.title = "Failure by Complaint";
        this.fetchChartDataComplaint();
      }
      if (this.type === "recycled-water-damage" || this.modelParam === "Water damage ") {
        this.title = "WATER DAMAGE";
        this.fetchChartDataWaterDamageRecycle();
      }
      if (this.type === "recycled-physical-damage" || this.modelParam === "Physical damage ") {
        this.title = "PHYSICAL DAMAGE";
        this.fetchChartDataPhysicalDamageRecycle();
      }
      if (this.type === "recycled-failure" || (this.type === "recycled" && this.modelParam === "Failure ")) {
        this.title = "FAILURE";
        this.fetchChartDataFailRecycle();
      }
      if (this.type === "recycled-model" || this.modelParam === "Model ") {
        this.title = "MODEL"
        this.fetchChartDataModelRecycle();
      }
      if (this.type === "recycled" || this.type === "units") {
        this.title = "RECYCLED"
        this.fetchChartDataRecycled();
      }
      if (this.type === "tested" && ((this.productGroup && this.productGroup.startsWith("Failure")) || this.modelParam === "Failure ")) {
        this.title = "FAILURE";
        this.fetchChartDataFailRecycle();
      }
      else if (this.type === "tested" && ((this.productGroup && this.productGroup.startsWith("Passed")) || this.modelParam.startsWith("Pass"))) {
        this.title = "PASS";
        this.fetchChartDataPassed();
      }
      else if (this.type === "tested" ) {
        this.title = "TESTED";
        this.fetchChartDataTested();
      }
      if (this.type === "processed-process") {
        this.title = "PROCESSED";
        this.fetchChartDataProcessed();
      }
      if (this.type === "warranty-repair") {
        this.title = "WARANTY REPAIR";
        this.fetchChartDataWarrantyRepair();
      }
      if (this.type === "arrivalDate") {
        this.title = "ARRIVAL DATE ON DOCK";
        this.fetchChartDataArrivalDate();
      }
      if (this.type === "historical" || this.type === "HISTORICAL") {
        this.fetchChartDataHistorical();
      }
      if (this.type === "totalTested") {
        this.title = "TOTAL TESTED";
        this.fetchChartDataTotalTested();
      }
       if (this.type === "inventory_status") {
        this.title = "INVENTORY STATUS";
        this.fetchChartInventoryStatusData();
      }
    },
    setTableBacklogColumns(schemaName) {
      this.fields = [
        { key: "fnsid", label: "ARC ID", sortable: true },
        { key: "sernm", label: "Serial#" },
        {
          key: "pMake",
          label: "Manufacturer",
          sortable: true,
          style: "width: 250px"
        },
        { key: "pMode", label: "Model" },
        {
          key: "compl",
          label: "Complaint",
          sortable: true,
          tdClass: "complaintClass"
        },
        { key: "loctn", label: "FNS Status", sortable: true },
        { key: "status", label: "Process Status", sortable: true },
        { key: "location", label: "Location" },
        { key: "flag", label: "Flag", sortable: true },
        { key: "recvD", label: "Receive Date", sortable: true },
      ]
    },
    setTableComcastARCColumns(schemaName) {
      this.fields = [
        {
          key: "arcId",
          label: "ARC ID",
          sortable: true,
        },
        { key: "raNumber", label: "RA Number" },
        { key: "bolNumber", label: "BOL Number", sortable: true },
        { key: "arcSerial", label: "ARC Serial" },
        {
          key: "productManufacturer",
          label: "Manufacturer",
          sortable: true,
          style: "width: 250px"
        },
        { key: "productModel", label: "Model" },
        {
          key: "fnsLocation",
          label: "Location",
          sortable: true,
        },
        { key: "receiveDate", label: "Receive Date", sortable: true },
        ...(this.type === "arrivalDate"
          ? [{ key: "dockingStatus", label: "Docking Status", sortable: true }]
          : []),
        ...(this.type === "inventory_status"
          ? [{ key: "inventoryStatus", label: "Inventory Status", sortable: true }]
          : []),
        ...(this.type === "tested" && ((this.productGroup && this.productGroup.startsWith("Failure")) || this.modelParam === "Failure ")
          ? [{ key: "reasonFlag", label: "Reason", sortable: true }]
          : [])
      ]
    },
    setTableComcastARCModelRecycleColumns(schemaName) {
      this.fields = [
        { key: "fnsProductManufacturer", label: "Product Manufacturer", sortable: true },
        { key: "fnsProductModel", label: "Product Model", sortable: true },
        { key: "fnsProductCount", label: "Product Count", sortable: true, style: "width: 250px" },
      ]
    },
    downloadExcel() {
      this.loading2019 = true;
      const params = this.excelDownloadParams;
      this.$http
        .get(this.excelDownloadUrl, { params, responseType: "blob" })
        .then(
          res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "TableReport.xlsx");
            document.body.appendChild(link);
            link.click();
            this.loading2019 = false;
          },
          err => {
            this.loading2019 = false;
            console.log(err);
          }
        );
    },
    setExcelDownloadData(url, params) {
      this.excelDownloadUrl = url;
      this.excelDownloadParams = { ...params, xml: "true" };
    },
    getApiData(url, params) {
      this.message = "";
      this.setExcelDownloadData(url, params);
      this.loading = true;
      this.$http.get(url, { params }).then(
        res => {
          if (res.data && res.data.records) {
            this.data = res.data.records;
            if (res.data.records && res.data.records.length > 0) {
              this.total = res.data.count || res.data.records.length;
            }
            this.message = "";
          } else if (res.data.message) {
            this.message = res.data.message;
            this.data = [];
            this.total = 0;
          }
          this.loading = false;
        },
        err => {
          this.loading = false;
          console.log(err);
        }
      );
    },
    fetchChartDataReceived() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        client_location: this.locationParam,
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {})
      };
      this.getApiData("api/comcast_arc/tables/received.php", params);
    },
    fetchChartDataShipped() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        equipment_status: this.equipment_status,
        client_location: this.locationParam,
        client: this.client,
        productType: productType,
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        prodModel: this.modelParam,
        thirdPartyClientId: this.manufacturer,
        fns_part: this.fns_part,
        ...(modelStore.isSpaced ? { spaced: true} : {})
      };
      this.getApiData("api/comcast_arc/tables/shipped.php", params);
    },
    fetchChartDataCityPerGroup() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        client_location: this.locationParam,
        client: this.client,
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {})
      };
      this.getApiData("api/comcast_arc/tables/shipped.php", params);
    },
    fetchChartDataWar() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        client_location: this.locationParam,
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {})
      };
      this.getApiData("api/comcast_arc/tables/war.php", params);
    },
    fetchChartDatabacklog() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        equipment_status: this.equipment_status,
        client_location: this.locationParam,
        client: this.client,
        productType: productType,
        prodModel: this.modelParam,
        fns_part: this.fns_part,
        ...(modelStore.isSpaced ? { spaced: true} : {})
      };
      this.setTableBacklogColumns();
      this.getApiData("api/comcast_arc/tables/back.php", params);
    },
    fetchChartDataPart() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        dateFrom: this.dateFromParam,
        dateTo: this.dateToParam,
        fns_part: this.fns_part,
        failure: this.failure,
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {})
      };
      this.getApiData("api/comcast_arc/tables/failureDataByPart.php", params);
    },
    fetchChartDataDesignator() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        dateFrom: this.dateFromParam,
        dateTo: this.dateToParam,
        fns_part: this.fns_part,
        failure: this.failure,
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {})
      };
      this.getApiData("api/comcast_arc/tables/failureDataByDesignator.php", params);
    },
    fetchChartDataFailure() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        dateFrom: this.dateFromParam,
        dateTo: this.dateToParam,
        fns_part: this.fns_part,
        failure: this.failure,
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {})
      };
      this.getApiData("api/comcast_arc/tables/failureDataByFailure.php", params);
    },
    fetchChartDataComplaint() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        dateFrom: this.dateFromParam,
        dateTo: this.dateToParam,
        fns_part: this.fns_part,
        failure: this.failure,
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {})
      };
      this.getApiData("api/comcast_arc/tables/failureDataByComplaint.php", params);
    },
    fetchChartDataWaterDamageRecycle() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        client_location: this.locationParam,
        client: this.client,
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {})
      };
      this.setTableComcastARCColumns();
      this.getApiData("api/comcast_arc/tables/water_damage_recycle.php", params);
    },
    fetchChartDataPhysicalDamageRecycle() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        client_location: this.locationParam,
        client: this.client,
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {})
      };
      this.setTableComcastARCColumns();
      this.getApiData("api/comcast_arc/tables/physical_damage_recycle.php", params);
    },
    fetchChartDataRecycled() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        client_location: this.locationParam,
        client: this.client,
        productType: productType,
      };
      this.setTableComcastARCColumns();
      this.getApiData("api/comcast_arc/tables/units.php", params);
    },
    fetchChartDataFailRecycle() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        client_location: this.locationParam,
        client: this.client,
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {})
      };
      this.setTableComcastARCColumns();
      this.getApiData("api/comcast_arc/tables/fail_recycle.php", params);
    },
    fetchChartDataModelRecycle() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        client_location: this.locationParam,
        client: this.client,
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {})
      };
      this.setTableComcastARCModelRecycleColumns();
      this.getApiData("api/comcast_arc/tables/model_recycle.php", params);
    },
    fetchChartDataPassed() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        client_location: this.locationParam,
        client: this.client,
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {})
      };
      this.setTableComcastARCColumns();
      this.getApiData("api/comcast_arc/tables/passed.php", params);
    },
    fetchChartDataTested() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        client_location: this.locationParam,
        client: this.client,
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {})
      };
      this.setTableComcastARCColumns();
      this.getApiData("api/comcast_arc/tables/tested.php", params);
    },
    fetchChartDataArrivalDate() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {}),
        ...(this.productGroup && this.productGroup.toLowerCase().includes('time') ? { isLateArrival : false} : {}),
        ...(this.productGroup && this.productGroup.toLowerCase().includes('late') ? { isLateArrival : true} : {})
      };
      this.setTableComcastARCColumns();
      this.getApiData("api/comcast_arc/tables/arrival_date.php", params);
    },
    fetchChartInventoryStatusData() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        client_location: this.locationParam,
        client: this.client,
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {}),
        ...(this.productGroup && this.productGroup.toLowerCase().includes('wip') ? { isRts : false} : {}),
        ...(this.productGroup && this.productGroup.toLowerCase().includes('rts') ? { isRts : true} : {})
      };
      this.setTableComcastARCColumns();
      this.getApiData("api/comcast_arc/tables/inventory_status.php", params);
    },
    fetchChartDataProcessed() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {})
      };
      this.setTableComcastARCColumns();
      this.getApiData("api/comcast_arc/tables/processed.php", params);
    },
    fetchChartDataWarrantyRepair() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {})
      };
      this.setTableComcastARCColumns();
      this.getApiData("api/comcast_arc/tables/warranty_repair.php", params);
    },
    onDatePickerModalEmit(changedDateFrom, changedDateTo) {
      this.dateFrom = changedDateFrom;
      this.dateTo = changedDateTo;
      this.fetchChartDataTotalTested();
    },
    modalDateEvent(modalId) {
      this.$bvModal.show(modalId);
    },
    setLastMonth() {
      const fromDate = new Date();
      fromDate.setDate(fromDate.getDate() - 30);
      this.dateFrom = new Date().toISOString().split('T')[0];
      this.dateTo = fromDate.toISOString().split('T')[0];
      this.fetchChartDataTotalTested();
    },
    setTableTotalTestedColumns() {
      this.fields = [
        { key: "shippingDate",      label: "Shipping Date",       sortable: true },
        { key: "fnsId",             label: "Fns Id",              sortable: true },
        { key: "productModel",      label: "Product Model",       sortable: true },
        { key: "cifaNumber",        label: "Cifa Number",         sortable: true },
        { key: "fqcDate",           label: "Fqc Date",            sortable: true },
        { key: "rtsDate",           label: "Rts Date",            sortable: true },
        { key: "warrantyRepairDate",label: "Warranty Repair Date",sortable: true },
        { key: "statusCode",        label: "Status Code",         sortable: true },
      ];
    },
    fetchChartDataTotalTested() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        date_from: this.dateFrom,
        date_to: this.dateTo,
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true } : {})
      };
      this.setTableTotalTestedColumns();
      this.getApiData("api/comcast_arc/tables/total_tested.php", params);
    },
    fetchChartDataHistorical() {
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      const params = {
        year: this.year,
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {})
      };
      this.getApiData("api/comcast_arc/tables/historical.php", params);
    }
  },
  mounted() {
    if (this.type === 'totalTested') {
      this.dateFrom = this.date_from || new Date().toISOString().split('T')[0];
      this.dateTo = this.date_to || (() => { const d = new Date(); d.setDate(d.getDate() - 30); return d.toISOString().split('T')[0]; })();
    }
    this.initLoad();
  }
};
</script>
<style>
.complaintClass {
  width: 200px;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.vdp-datepicker .input-group input {
  background: #515b65 !important;
}
.download-button {
  width: 150px;
  margin: auto;
  float: right;
  font-weight: 500;
  border-radius: 0.3rem;
  color: white;
  background: #20a8d8;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.sk-double-bounce {
  display: inline-block;
  line-height: 55px;
  margin: auto;
}

.download-button:hover {
  text-decoration: none !important;
  color: white;
}
.fa-file-excel-o {
  color: #ffffff68;
  padding-right: 0.5em;
}
</style>
